function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Button, Card, Divider, Checkbox, Result, Image } from "antd";
import { QuestionCircleFill, SaveFill } from 'react-bootstrap-icons';
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
var Meta = Card.Meta;

var Modules = function Modules() {
  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isLabActive = _useState2[0],
      setIsLabActive = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isMcheckActive = _useState4[0],
      setIsMcheckActive = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      isImActive = _useState6[0],
      setIsImActive = _useState6[1];

  var _useState7 = useState(false),
      _useState8 = _slicedToArray(_useState7, 2),
      isCustomerActive = _useState8[0],
      setIsCustomerActive = _useState8[1];

  var _useState9 = useState(false),
      _useState10 = _slicedToArray(_useState9, 2),
      isAccountingActive = _useState10[0],
      setIsAccountingActive = _useState10[1];

  var _useState11 = useState(false),
      _useState12 = _slicedToArray(_useState11, 2),
      isOphtaActive = _useState12[0],
      setIsOphtaActive = _useState12[1];

  useEffect(function () {}, []);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsx(Row, {
        className: "d-flex justify-content-center",
        children: /*#__PURE__*/_jsx(Col, {
          lg: 6,
          children: /*#__PURE__*/_jsx(Result, {
            icon: /*#__PURE__*/_jsx(Image, {
              preview: false,
              width: "70%",
              src: "/drawables/play.gif"
            }),
            title: "Votre compte \xE0 \xE9t\xE9 cr\xE9\xE9 !",
            subTitle: "Vous \xEAtes pr\xEAt \xE0 commencer, choisissez une des actions pour g\xE9rer vos donn\xE9es m\xE9dicales d\xE8s maintenant.",
            extra: [/*#__PURE__*/_jsx(Button, {
              size: "large",
              href: "/#/home/departments",
              type: "primary",
              children: /*#__PURE__*/_jsx("b", {
                children: "Configurez les tarifs"
              })
            }), /*#__PURE__*/_jsx(Button, {
              size: "large",
              href: "/#/home/cashier",
              type: "defautl",
              children: /*#__PURE__*/_jsx("b", {
                children: "Cr\xE9er un dossier m\xE9dical"
              })
            })]
          })
        })
      })
    })
  });
};

export default Modules;